import { filter, get } from "lodash";
import { GadmFeature } from "./types";

// Carga dinámicamente el GeoJSON de un país y nivel específico,
// opcionalmente filtrando los features por GID del padre
export const loadGeoJson = async (
  country: string,
  level: number,
  parentGid?: string
): Promise<GadmFeature[]> => {
  const module = await import(`./geojson/${country}/${level}.json`);
  const features: GadmFeature[] = get(module, "default.features", module.features ?? []);

  if (!parentGid) return features;

  // El campo padre en el nivel N es GID_{N-1}
  const parentField = `GID_${level - 1}`;
  return filter(features, (f) => get(f, `properties.${parentField}`) === parentGid);
};
